import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { FocusModeService } from '@dep/frontend/shared/services/focus-mode.service';

@Component({
  selector: 'app-admin-root',
  templateUrl: './admin-root.component.html',
  styleUrls: ['./admin-root.component.scss'],
  standalone: false,
})
export class AdminRootComponent implements OnInit, OnDestroy {
  public canShowSideNavidation = false;
  public isFocusModeActive = false;
  public showChatWidget = false;
  private focusModeSub$?: Subscription;

  constructor(
    private readonly router: Router,
    private readonly focusModeService: FocusModeService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Show side navigation if the current route is not '/home', '/start' and root ('/').
        this.canShowSideNavidation = (event.url !== '/home' && event.url !== '/start' && event.url !== '/');
        this.showChatWidget = event.url.startsWith('/clients') || event.url.startsWith('/support');
      }
    });
  }

  public ngOnInit(): void {
    this.focusModeSub$ = this.focusModeService.focusModeSubject.subscribe((isFocusModeActive: boolean) => {
      this.isFocusModeActive = isFocusModeActive;
    });
  }

  public ngOnDestroy(): void {
    this.focusModeSub$?.unsubscribe();
  }
}
